import {Paper, Stack} from '@mui/material';
import {Question} from '@cp/model';
import ImageDisplayFromStorage from '../../../atoms/imageDisplayFromStorage/ImageDisplayFromStorage';
import BondGraphRenderer from '../../../bonds/bondGraphRenderer/BondGraphRenderer';
import SessionQuestionAnswerList from '../../session/SessionQuestionAnswerList';
import AdminQuestionReviewQuestionFeedback from './AdminQuestionReviewQuestionFeedback';
import AdminQuestionReviewQuestionHeader from './AdminQuestionReviewQuestionHeader';
import RenderedHint from '../../../atoms/RenderedHint/RenderedHint';
import AdminQuestionReviewQuestionStatusNote from './AdminQuestionReviewQuestionStatusNote';
import AdminQuestionReviewQuestionStatusUpdate from './AdminQuestionReviewQuestionStatusUpdate';
import AdminQuestionReviewQuestionSubmitButton from './AdminQuestionReviewQuestionSubmitButton';
import AdminQuestionReviewQuestionText from './AdminQuestionReviewQuestionText';

export interface AdminQuestionReviewQuestionDisplayProps {
  question: Question;
  selectedAnswer: string;
  showFeedback: boolean;
  isCorrect: boolean;
  nextStep: any;
  updateLoading: boolean;
  isAdmin: boolean;
  isReviewer: boolean;
  sessionQuestion: any;
  onAnswerSelect: (answer: string) => void;
  onSubmitAnswer: () => void;
  onUpdateStatus: (status: any) => void;
}

export default function AdminQuestionReviewQuestionDisplay({
  question,
  selectedAnswer,
  showFeedback,
  isCorrect,
  nextStep,
  updateLoading,
  isAdmin,
  isReviewer,
  sessionQuestion,
  onAnswerSelect,
  onSubmitAnswer,
  onUpdateStatus,
}: AdminQuestionReviewQuestionDisplayProps) {
  return (
    <Paper sx={{p: 3}}>
      <Stack direction="column" gap={3}>
        <AdminQuestionReviewQuestionHeader question={question} />

        {isAdmin && <AdminQuestionReviewQuestionStatusNote question={question} />}

        <BondGraphRenderer graphJsonString={question.graphJsonString} />

        <ImageDisplayFromStorage imageUrl={question.imageUrl} />

        <AdminQuestionReviewQuestionText questionText={question.questionText} />

        {sessionQuestion && (
          <SessionQuestionAnswerList
            currentQuestion={sessionQuestion}
            selectedAnswer={selectedAnswer}
            handleAnswerSelect={onAnswerSelect}
            disabled={showFeedback}
          />
        )}

        {!showFeedback && (
          <AdminQuestionReviewQuestionSubmitButton disabled={!selectedAnswer} onClick={onSubmitAnswer} />
        )}

        {showFeedback && <AdminQuestionReviewQuestionFeedback question={question} isCorrect={isCorrect} />}

        {showFeedback && question.hint && <RenderedHint hint={question.hint} />}

        {showFeedback && (
          <AdminQuestionReviewQuestionStatusUpdate
            question={question}
            nextStep={nextStep}
            updateLoading={updateLoading}
            isReviewer={isReviewer}
            onUpdateStatus={onUpdateStatus}
          />
        )}
      </Stack>
    </Paper>
  );
}
